import { render, staticRenderFns } from "./CriteriaEdit.vue?vue&type=template&id=e53f579e"
import script from "./CriteriaEdit.vue?vue&type=script&lang=js"
export * from "./CriteriaEdit.vue?vue&type=script&lang=js"
import style0 from "./CriteriaEdit.vue?vue&type=style&index=0&id=e53f579e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports